import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { UserIcon } from 'lucide-react';
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function TeamSlide() {
  return <motion.div className="w-full h-full flex flex-col px-12 py-10" variants={stagger} initial="hidden" animate="visible" data-id="element-345">
      <motion.div variants={fadeUp} className="flex items-center gap-3 mb-2" data-id="element-346">
        <span className="text-base text-[#00d4ff] font-semibold tracking-widest uppercase" data-id="element-347">
          09
        </span>
        <span className="w-8 h-[1px] bg-[#00d4ff] opacity-50" data-id="element-348" />
      </motion.div>

      <motion.h2 variants={fadeUp} className="text-4xl md:text-5xl font-extrabold text-white mb-3" data-id="element-349">
        Team
      </motion.h2>

      <motion.p variants={fadeUp} className="text-2xl text-[#8899aa] mb-8" data-id="element-350">
        Domain experts in FPGAs, AI systems, and cloud infrastructure
      </motion.p>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-351">
        {/* Nour */}
        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col" data-id="element-352">
          <div className="w-14 h-14 rounded-full bg-[rgba(0,212,255,0.1)] flex items-center justify-center mb-4 border border-[rgba(0,212,255,0.2)]" data-id="element-353">
            <UserIcon className="w-6 h-6 text-[#00d4ff]" data-id="element-354" />
          </div>
          <p className="text-2xl font-bold text-white mb-1" data-id="element-355">Nour</p>
          <p className="text-lg text-[#00d4ff] font-semibold mb-3" data-id="element-356">CEO</p>
          <p className="text-[17px] text-white/70 leading-relaxed flex-1" data-id="element-357">
            Mined 25% of Bittensor network by building a cracked team of GPU
            devs to port the mining algos when only CPU was enabled.
          </p>
        </motion.div>

        {/* Orion */}
        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col" data-id="element-358">
          <div className="w-14 h-14 rounded-full bg-[rgba(255,107,53,0.1)] flex items-center justify-center mb-4 border border-[rgba(255,107,53,0.2)]" data-id="element-359">
            <UserIcon className="w-6 h-6 text-[#ff6b35]" data-id="element-360" />
          </div>
          <p className="text-2xl font-bold text-white mb-1" data-id="element-361">Orion</p>
          <p className="text-lg text-[#ff6b35] font-semibold mb-3" data-id="element-362">CFO</p>
          <p className="text-[17px] text-white/70 leading-relaxed flex-1" data-id="element-363">
            Co-founded orangedao.xyz, community of YC-backed founders, deployed
            $26M fund into 200 web3 startups, achieving 2.2X MOIC at Y3. EE with
            patent for a portable scalable signal processor.
          </p>
        </motion.div>

        {/* Faris */}
        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col" data-id="element-364">
          <div className="w-14 h-14 rounded-full bg-[rgba(255,255,255,0.05)] flex items-center justify-center mb-4 border border-[rgba(255,255,255,0.1)]" data-id="element-365">
            <UserIcon className="w-6 h-6 text-[#8899aa]" data-id="element-366" />
          </div>
          <p className="text-2xl font-bold text-white mb-1" data-id="element-367">Faris</p>
          <p className="text-lg text-[#8899aa] font-semibold mb-3" data-id="element-368">
            Co-Founder
          </p>
          <p className="text-[17px] text-white/70 leading-relaxed flex-1" data-id="element-369">
            Faris Oweis is a growth and revenue leader in crypto and AI who has
            driven over $100M in TVL, helped clients raise $120M from top
            investors, and managed liquidity providers with more than $2B in
            assets.
          </p>
        </motion.div>
      </div>

      {/* Advisors note */}
      <motion.div variants={fadeUp} className="mt-5 glass-card p-4" data-id="element-370">
        <p className="text-[17px] text-[#8899aa]" data-id="element-371">
          <span className="text-white/60 font-medium" data-id="element-372">+ Advisors</span> in
          semiconductors, cloud infrastructure, and AI
        </p>
      </motion.div>
    </motion.div>;
}